/* CloneAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("../create/CreateQuestionComponent");
const _ = require("lodash");

const CLONE_PROPS = [
    "address",
    "adminContact",
    "autoAssignEnabled",
    "autoAssignProperty",
    "autoAssignRegex",
    "country",
    "description",
    "latitude",
    "location",
    "locationType",
    "longitude",
    "technicalContact",
    "timezone",
];

class CloneAction {
    constructor(logger, gameEditor, modalUserFeedback, SiteEntity, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._SiteEntityDef = SiteEntity;
        this._siteEntity = new SiteEntity(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;

        this.userSession = userSession;

        this._firstRun = true;

        this.run = this.run.bind(this);
        this.cloneErrorHandler = this.cloneErrorHandler.bind(this);
    }
    run() {
        if (
            !this._activeView ||
            !this._activeView.selectedRows ||
            this._activeView.selectedRows.length <= 0
        ) {
            return Promise.reject("Active view or selection not available");
        }
        return this._SiteEntityDef
            .loadSite(this.userSession.activeOrganization.id, this._activeView.selectedRows[0])
            .then((site) => {
                this._selectedSite = site;
                if (site.id === this.userSession.activeOrganization.id) {
                    return this.showError({
                        errorMsg: "Sorry, you can’t clone the root site.",
                        errorTitle: "Clone Site",
                        errorCode: "",
                    });
                }

                this._siteEntity.name = this._selectedSite.name.trim() + "-1";
                this._siteEntity.codeName = this._selectedSite.codeName.trim() + "-1";

                for (let i = 0; i < CLONE_PROPS.length; i++) {
                    this._siteEntity[CLONE_PROPS[i]] = this._selectedSite[CLONE_PROPS[i]];
                }

                // clone customfields
                let customFields = {};
                Object.keys(this._selectedSite.customFieldValues).forEach((key) => {
                    if (!this._selectedSite.customFieldSources[key]) {
                        customFields[key] = this._selectedSite.customFieldValues[key];
                    }
                });
                this._siteEntity.customFieldValues = customFields;

                if (this._selectedSite.parentId) {
                    this._siteEntity.setParentSiteRelationship(this._selectedSite.parentId);
                }
                return this.cloneSite();
            })
            .catch(this.cloneErrorHandler);
    }
    cloneErrorHandler(err) {
        if (err.userRejected) {
            return this._modalUserFeedback.hideDisplayed();
        }
        const errorCode = err && err.errorCode;
        this._logger.warn({error: err}, "Clone action error.");

        switch (errorCode) {
            case "EntityAlreadyExists":
                if (this._firstRun) {
                    this._firstRun = false;
                    return this.requestSiteData(false);
                }
                return this.requestSiteData(true);
            default:
                return this.showError(err);
        }
    }
    launchSiteEditor(id, name) {
        if (!id) {
            throw "Site creation error, invalid site id.";
        }
        let editorState = {
            fqn: Registrations.SIE_VIEW_DETAILS,
            viewState: {createMode: true},
        };
        let launchOpts = {id: id, title: name};
        return this._gameEditor.launchDeviceEditor(editorState, launchOpts);
    }

    cloneSite() {
        let newItemId;
        return this._siteEntity
            .create()
            .then((result) => {
                newItemId = result.id;
                return this._modalUserFeedback.hideDisplayed().then(() => {
                    return this.launchSiteEditor(result.id, result.properties.name);
                });
            })
            .then(() => {
                if (typeof this._activeView.resetSelection === "function") {
                    // making a small delay, to be sure the grid is updated with new item
                    _.delay(() => this._activeView.resetSelection([newItemId]), 1500);
                }
                return Promise.resolve(this);
            });
    }

    requestSiteData(/*isNotUniq*/) {
        this._modalUserFeedback
            .displayCustom(new CreateQuestionComponent(this._logger), {dontHide: true})
            .then((result) => {
                return this._modalUserFeedback.displayLoading().then(() => {
                    this._siteEntity.name = result.name.trim();
                    this._siteEntity.codeName = result.code.trim();
                    return this.cloneSite();
                });
            })
            .catch(this.cloneErrorHandler);
    }

    showError(error) {
        return this._modalUserFeedback.displayError({error}).catch((error) => {
            if (error.userRejected) {
                return;
            }
            this._logger.warn({error}, "Clone action error.");
        });
    }
}

module.exports = CloneAction;

CloneAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Site",
    "$teve.userSession",
    "gameEditor.activeView",
];

CloneAction.$displayDetails = {
    type: "Action",
    name: "CloneAction",
    icon: "common.duplicate",
    title: "Clone site",
    shown: true,
    order: 5,
};
